import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CartOrderMergeStrategy } from 'src/app/order-user/enums/cart-order-merge-strategy.enum';

export interface CartMergeStrategyModalData {
  overlapCount: number;
}

@Component({
  selector: 'app-cart-merge-strategy-modal',
  templateUrl: './cart-merge-strategy-modal.component.html',
  styleUrls: ['./cart-merge-strategy-modal.component.scss'],
  standalone: false,
})
export class CartMergeStrategyModalComponent {
  readonly strategyControl = new FormControl<CartOrderMergeStrategy>(
    CartOrderMergeStrategy.MergeQuantities,
    { nonNullable: true, validators: [Validators.required] }
  );
  readonly strategies = CartOrderMergeStrategy;

  constructor(
    private dialogRef: MatDialogRef<CartMergeStrategyModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CartMergeStrategyModalData
  ) {}

  confirm(): void {
    if (this.strategyControl.invalid) {
      return;
    }

    this.dialogRef.close(this.strategyControl.value);
  }
}
